import { CButton } from "@coreui/react"
import { GridApi } from "ag-grid-community";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { States } from "../store/ducks/rootReducer";
import { Acesso } from "../models/Acesso";
import { apiDaPagina, apiNegada } from "../services/acesso";

export interface ActionProps {
    type: 'normal' | 'grid' | 'post' | 'get' | 'delete' | 'custom' ,
    route: string,
    title:string,
    color?:string,
    gridApi?:GridApi,
    rowParams?:Object[],
    fixedParams?:Object[],
    callBackFunction?:Function,
    onClickFunction?:(rows:any[], route:string)=>void,
    validate?:(rows:any[])=>boolean,
    openInNewTab?: boolean,
}

type Props = ActionProps & CButton

/**
 * Botao que certamente daria 403 nao aparece (#484909). Exclusao e post
 * chamam a API direto ("x/delete" vira DELETE /x/delete/{id}); incluir e
 * alterar abrem a pagina que grava em POST /x/add e /x/edit/{id}.
 */
export const acaoPermitida = (acesso: Acesso | undefined, action: ActionProps): boolean => {
    if (!acesso) {
        return true;
    }
    switch (action.type) {
        case 'delete':
            return !apiNegada(acesso, 'DELETE', `${action.route}/0`) && !apiNegada(acesso, 'DELETE', action.route);
        case 'post':
            return !apiNegada(acesso, 'POST', `${action.route}/0`) && !apiNegada(acesso, 'POST', action.route);
        default:
            const api = apiDaPagina(action.route);
            return !api || !apiNegada(acesso, api[0], api[1]);
    }
};

const GridAction  = (props:Props) =>{
    const [gridApiInterno, setGridApi] = useState<GridApi>();

    useEffect(()=>{
        setGridApi(
            (prevApi) => props.gridApi
        )
    }, [props.gridApi]);

    const history = useHistory();
    const acesso = useSelector((state:States)=> state.login.data?.acesso);

    const onClickHandle = () =>{
        if (props.openInNewTab) {
            let id = gridApiInterno?.getSelectedRows()[0].id;
            window.open('#' + props.route+`/${id}`, '_blank');
            return;
        }
        switch(props.type){
            case 'normal':
                history.push(props.route);
            break;
            case 'grid':
                let id = gridApiInterno?.getSelectedRows()[0].id;
                history.push(props.route+`/${id}`);
            break;
            case 'post':
            case 'delete':
                if(gridApiInterno?.getSelectedRows() && props.onClickFunction){
                    let rows = gridApiInterno?.getSelectedRows();
                    props.onClickFunction(rows, props.route);
                }
            break;
            case 'custom':
                let idSelect = gridApiInterno?.getSelectedRows()[0]?.id;
                if (idSelect > 0){
                    history.push(props.route+`/${idSelect}`);
                }else {
                    history.push(props.route);
                }
            break;
        }
    }

    let {gridApi , validate, onClickFunction,openInNewTab, ...rest} = props;

    if (!acaoPermitida(acesso, props)) {
        return null;
    }

    return (
        <CButton onClick={onClickHandle} {...rest}>
            {props.children}
        </CButton>
    )
}

export default GridAction